import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const PremiumColors = createInteractiveColorVars('premium');
const PremiumColorsLightValues = Object.freeze({
    base: {
        default: '#158380',
        action: '#0E5957',
        active: '#158380',
        activeAction: '#0E5957',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});
const PremiumColorsDarkValues = Object.freeze({
    base: {
        default: '#158380',
        action: '#0E5957',
        active: '#158380',
        activeAction: '#0E5957',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});

export { PremiumColors, PremiumColorsDarkValues, PremiumColorsLightValues };
